// Reddit Pixel utility - opt-in via VITE_REDDIT_PIXEL_ID env var

const PIXEL_ID = import.meta.env.VITE_REDDIT_PIXEL_ID as string | undefined;

let pixelInitialized = false;

declare global {
  interface Window {
    rdt?: (...args: unknown[]) => void;
  }
}

export function isRedditPixelEnabled(): boolean {
  return Boolean(PIXEL_ID && typeof window !== 'undefined');
}

export function trackRedditEvent(
  eventName: string,
  eventParams?: Record<string, unknown>
): void {
  if (!isRedditPixelEnabled()) return;
  if (typeof window.rdt !== 'function') return;

  window.rdt('track', eventName, eventParams ?? {});
}

export function initRedditPixel(): void {
  if (!PIXEL_ID) return;
  if (typeof window === 'undefined') return;
  if (pixelInitialized) return;

  // Inject Reddit pixel loader script
  if (!window.rdt) {
    const script = document.createElement('script');
    script.innerHTML = `!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);`;
    document.head.appendChild(script);
  }

  window.rdt?.('init', PIXEL_ID);
  window.rdt?.('track', 'PageVisit');
  pixelInitialized = true;
}
